import { useEffect, useState } from 'react';
import { Modal } from 'react-responsive-modal';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { Button } from 'reactstrap';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { addProjectTask, getProjects } from '../../../redux/MainAction';
import { toast } from 'react-toastify';

const AddTaskModel = ({ open, onClose }) => {
  const param = useParams();
  const dispatch = useDispatch();
  const tmlist = useSelector((state) => state.Webtracker.member);
  const prjlist = useSelector((state) => state.Webtracker.projects);

  const [empDataOption, setEmpDataOption] = useState([]);
  const [empDataValue, setEmpDataValue] = useState([]);

  const [addData, setAddData] = useState({
    priority: 'URGENT',
    name: '',
    description: '',
    projectId: '',
    startDate: '',
    endDate: '',
    timeEstimate: '',
    budgetEstimate: '',
  });

  const onChangeData = (e) => {
    const { name, value } = e.target;
    setAddData({ ...addData, [name]: value });
  };

  useEffect(() => {
    if (!prjlist || !Array.isArray(prjlist?.rows)) getList();
  }, [prjlist]);

  console.log(prjlist);

  const getList = () => {
    var data = {
      offset: 0,
      limit: 10,
    };
    dispatch(getProjects(data));
  };

  useEffect(() => {
    if (tmlist && tmlist?.rows) {
      const option = tmlist?.rows?.map((user) => {
        return {
          label: `${user?.firstName} ${user?.lastName}`,
          value: user?.id,
        };
      });
      setEmpDataOption(option);
    }
  }, [tmlist]);

  const onEmployeeChange = (value) => {
    if (value) {
      setEmpDataValue(value);
    }
  };

  const onSaveHandle = (e) => {
    e.preventDefault();

    if (addData?.name === '') {
      toast.error('Please add name !', {
        position: 'top-right',
      });
      return false;
    }
    if (addData?.projectId === '') {
      toast.error('Please add Project!', {
        position: 'top-right',
      });
      return false;
    }

    const ids = empDataValue?.map((itm) => itm?.value);

    const dataAdd = {
      projectId: addData?.projectId,
      name: addData?.name,
    };

    if (addData?.priority !== '') {
      dataAdd.priority = addData?.priority;
    }
    if (addData?.budgetEstimate !== '') {
      dataAdd.budgetEstimate = addData?.budgetEstimate;
    }
    if (addData?.timeEstimate !== '') {
      dataAdd.timeEstimate = addData?.timeEstimate;
    }
    if (addData?.description !== '') {
      dataAdd.description = addData?.description;
    }
    if (addData?.startDate !== '') {
      dataAdd.startDate = addData?.startDate;
    }
    if (addData?.endDate !== '') {
      dataAdd.endDate = addData?.endDate;
    }
    if (ids.length > 0) {
      dataAdd.employeeIds = ids;
    }

    dispatch(addProjectTask(dataAdd));
    onClose();

    setAddData({
      priority: 'URGENT',
      name: '',
      description: '',
      startDate: '',
      endDate: '',
      timeEstimate: '',
      budgetEstimate: '',
    });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      showCloseIcon={false}
      classNames={{ modal: 'custom-modal' }}
    >
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5>New Task</h5>
        <i
          onClick={onClose}
          className="fa fa-times font-20"
          style={{ cursor: 'pointer' }}
        ></i>
      </div>
      <div className="tab-content">
        <div className="row col-12">
          <div className="form-group col-6">
            <label for="username1" className="font-14 text-muted ">
              Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Name"
              className="form-control"
              name="name"
              value={addData?.name}
              onChange={onChangeData}
              id="username1"
            />
          </div>
          <div className="form-group col-6">
            <label className="text-muted">Task Priority</label>
            <div>
              <select
                className="form-control"
                name="priority"
                value={addData?.priority}
                onChange={onChangeData}
              >
                <option>Select Priority</option>
                <option value="URGENT">Urgent</option>
                <option value="HIGH">High</option>
                <option value="NORMAL">Normal</option>
                <option value="LOW">Low</option>
              </select>
            </div>
          </div>
        </div>
        <div
          className=" form-group"
          style={{ marginLeft: '10px', width: '520px' }}
        >
          <label className="control-label">Select Employee</label>
          <Select
            value={empDataValue}
            onChange={onEmployeeChange}
            options={empDataOption}
            isMulti={true}
          />
        </div>
        <div
          className="form-group"
          style={{ marginLeft: '10px', width: '520px' }}
        >
          <label className="text-muted">
            Project <span className="text-danger">*</span>
          </label>
          <div className="">
            <select
              className="form-control"
              name="projectId"
              value={addData?.projectId}
              onChange={onChangeData}
            >
              <option value={''}>Select Project</option>
              {prjlist?.rows?.map((itm, idx) => (
                <option key={idx} value={itm?.id}>
                  {itm?.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="row col-12">
          <div className="form-group col-6">
            <label for="D14" className="font-14 text-muted ">
              Estimate Time
            </label>
            <input
              type="number"
              className="form-control"
              name="timeEstimate"
              placeholder="0"
              value={addData?.timeEstimate}
              onChange={onChangeData}
              id="D4"
            />
          </div>
          <div className="form-group col-6">
            <label for="D5" className="font-14 text-muted ">
              Estimate Budget
            </label>
            <input
              type="number"
              className="form-control"
              name="budgetEstimate"
              value={addData?.budgetEstimate}
              onChange={onChangeData}
              placeholder="0"
              id="D5"
            />
          </div>
        </div>
        <div className="row col-12">
          <div className="form-group col-6">
            <label for="D1" className="font-14 text-muted ">
              Start Date
            </label>
            <input
              type="date"
              className="form-control"
              name="startDate"
              value={addData?.startDate}
              onChange={onChangeData}
              id="D1"
            />
          </div>
          <div className="form-group col-6">
            <label for="D2" className="font-14 text-muted ">
              End Date
            </label>
            <input
              type="date"
              className="form-control"
              name="endDate"
              value={addData?.endDate}
              onChange={onChangeData}
              id="D2"
            />
          </div>
        </div>
        <div className="row col-12">
          <div className="form-group col-12">
            <label>Description</label>
            <textarea
              type="text"
              className="form-control"
              name="description"
              value={addData?.description}
              onChange={onChangeData}
              rows={4}
              placeholder=""
            />
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <Button size="sm" className="btn btn-light" onClick={onClose}>
          Cancel
        </Button>
        <Button size="sm" className="btn btn-purple" onClick={onSaveHandle}>
          Create Task
        </Button>
      </div>
    </Modal>
  );
};

export default AddTaskModel;
